var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"home"},[_c('router-view',{staticClass:"home__nav",attrs:{"name":"nav"}}),_c('router-view',{staticClass:"home__content",attrs:{"name":"content"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }